import { useIsMobile } from '@yes.technology/react-toolkit'
import { useBreakpoint } from 'shared/hooks/useBreakpoint'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import BannerImage from './BannerImage'
import {
  ButtonsWrapper,
  Container,
  Content,
  CustomLinkButton,
  HeroImage,
  Subtitle,
  Title
} from './HeroBanner.styles'
import { HeroBannerProps } from './HeroBanner.types'

const HeroBanner = ({
  des,
  complement,
  buttons,
  backgroundImageUrl,
  backgroundImageUrlMobile,
  preTitleImage,
  postTitleImage,
  imageAlt,
  backgroundPositionDesktop = 'center bottom',
  backgroundPositionMobile = 'top center',
  desColor = '#646E82',
  complementColor = '#646E82',
  styleMap = {}
}: HeroBannerProps) => {
  const hasContent = !!des || !!complement || !!buttons

  const isMobile = useIsMobile()

  const breakpoint = useBreakpoint()

  const styles = useStyleMaps(styleMap)

  if (!hasContent) {
    return (
      <HeroImage
        src={
          isMobile && backgroundImageUrlMobile
            ? backgroundImageUrlMobile
            : backgroundImageUrl
        }
        alt={imageAlt}
        breakpoint={breakpoint}
      />
    )
  }

  return (
    <Container
      bg={backgroundImageUrl}
      bgPosition={{ backgroundPositionDesktop, backgroundPositionMobile }}
      breakpoint={breakpoint}
      style={styles}
    >
      <Content>
        {preTitleImage && <BannerImage image={preTitleImage} />}
        <Title color={desColor}>{des}</Title>
        {postTitleImage && <BannerImage image={postTitleImage} />}
        <Subtitle color={complementColor}>{complement}</Subtitle>
        {buttons && (
          <ButtonsWrapper>
            {buttons.map(
              ({ label, href, target = '_self', style, disabled }, index) => (
                <CustomLinkButton
                  key={`ButtonHeroBanner-${index}`}
                  href={href}
                  variant='secondary'
                  heightClass='large'
                  rel='noopener noreferrer'
                  style={style}
                  {...{ target, disabled }}
                >
                  {label}
                </CustomLinkButton>
              )
            )}
          </ButtonsWrapper>
        )}
      </Content>
    </Container>
  )
}

export default HeroBanner
